var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableTennis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2595 13.8957C24.7358 10.2494 24 5.91407 21.0473 2.9567C17.1151 -0.984914 10.7363 -0.984914 6.80409 2.9567L4.17947 5.586L14.0921 15.4986C16.2527 12.5881 20.2552 11.871 23.2595 13.8957ZM13.0469 17.6311L2.71719 7.30606C1.43769 9.42918 1.70015 12.2272 3.528 14.0598L5.14495 15.6814L0.317537 19.8714C-0.0855285 20.2229 -0.108963 20.8416 0.270669 21.2212L2.77343 23.7286C3.14837 24.1083 3.76703 24.0848 4.11854 23.6818L8.30387 18.8403L9.97706 20.5135C10.9004 21.4368 12.0674 21.943 13.2719 22.0742C12.9391 21.2774 12.7563 20.4057 12.7563 19.4918C12.7517 18.845 12.8735 18.2263 13.0469 17.6311ZM19.5007 14.9971C17.0166 14.9971 15.0013 17.0124 15.0013 19.4965C15.0013 21.9805 17.0166 23.9958 19.5007 23.9958C21.9847 23.9958 24 21.9805 24 19.4965C24 17.0124 21.9847 14.9971 19.5007 14.9971Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default ForwardRef;